<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div class="bodyCenter">
      <div class="modalStyle">
        <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span class="fa fa-table"></span>
            <span>Reporte de seguimiento Ptis</span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>Rep_PTI_M2</div>
          </b-col>
        </b-row>

        <b-tabs content-class="mt-3" fill>
          <div class="flxDivs">
            <div>
              <b-tabs content-class="mt-3" fill>
                <b-tab title="Presupuestadas por CDXE" active
                     v-if="$localStorageService.can('Rep_presupuest_cdx_m2')">
                  <reportePTIPresupuestadoCDXE/>
                </b-tab>
                <b-tab title="Ptis en revisión"
                      v-if="$localStorageService.can('Rep_M2_revision')">  
                      <reportePtiRevision/>
                    </b-tab>
                <b-tab title="Ptis presentados"
                       v-if="$localStorageService.can('Rep_presupuest_pagad_m2')">
                  <reportePtiPresentados/>
                </b-tab>
                <b-tab title="Ptis aceptados"
                      v-if="$localStorageService.can('Rep_presupuest_acep_m2')">
                  <reportePtiAceptados/>
                </b-tab>
                <b-tab title="Ptis pagados"
                       v-if="$localStorageService.can('Rep_presupuest_pagad_m2')">
                  <reportePtiPagados/>
                </b-tab>
              </b-tabs></div>
          </div>

        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import reportePTIPresupuestadoCDXE from "./reportePTIPresupuestadoCDXE";
import reportePtiAceptados from "./reportePtiAceptados";
import reportePtiPagados from "./reportePtiPagados";
import reportePtiPresentados from "./reportePtiPresentados";
import reportePtiRevision from "@/views/Reportes/PTIS/reportePtiRevision";

export default {
  name: "reporteEscenariosPTIs",

  components: {
    Header,
    reportePTIPresupuestadoCDXE,
    reportePtiAceptados,
    reportePtiPagados,
    reportePtiPresentados,
    reportePtiRevision,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

  }),

  methods: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>